export const SESSIONS_GROUP_DATE_TYPE = {
  COMING: "COMING",
  TODAY: "TODAY",
  DONE: "DONE",
};

export const SESSIONS_GROUP_TYPE = {
  ...SESSIONS_GROUP_DATE_TYPE,
  CANCELLED: "CANCELLED",
};

export const SESSIONS_GROUP_STATUS_TYPE = {
  PUBLISHED: "PUBLISHED",
  UNPUBLISHED: "UNPUBLISHED",
};
